import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FoodDatabase = ({ onClose }) => {
  const [foods, setFoods] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMealType, setSelectedMealType] = useState('snack');
  const [filterType, setFilterType] = useState('');
  const [filterRegion, setFilterRegion] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFoods();
  }, []);

  const fetchFoods = async () => {
    try {
      const response = await axios.get(`${API}/foods/database`);
      setFoods(response.data);
    } catch (error) {
      console.error('Error fetching foods:', error);
    } finally {
      setLoading(false);
    }
  };

  const logFood = async (foodId) => {
    try {
      await axios.post(`${API}/meals/log-from-database?food_id=${foodId}&meal_type=${selectedMealType}`);
      onClose();
    } catch (error) {
      alert('Failed to log food: ' + error.message);
    }
  };

  const filteredFoods = foods.filter(food => {
    const matchesSearch = food.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = !filterType || food.type === filterType;
    const matchesRegion = !filterRegion || food.region === filterRegion || food.region === 'All';
    const matchesCategory = !filterCategory || food.category === filterCategory;
    return matchesSearch && matchesType && matchesRegion && matchesCategory;
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="p-6 border-b" style={{ borderColor: 'rgba(24, 24, 24, 0.1)' }}>
          <div className="flex justify-between items-center mb-4">
            <div>
              <h2 className="heading-3" style={{ color: 'rgb(24, 24, 24)' }}>Indian Foods Database</h2>
              <p className="body-small" style={{ color: 'rgb(112, 112, 112)' }}>
                {filteredFoods.length} items found
              </p>
            </div>
            <button onClick={onClose} className="text-2xl" style={{ color: 'rgb(112, 112, 112)' }}>×</button>
          </div>
          
          <input
            type="text"
            placeholder="Search for food..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
            style={{ borderColor: 'rgba(24, 24, 24, 0.2)' }}
          />
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div>
              <label className="body-small block mb-1" style={{ color: 'rgb(24, 24, 24)' }}>Region</label>
              <select
                value={filterRegion}
                onChange={(e) => setFilterRegion(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ borderColor: 'rgba(24, 24, 24, 0.2)' }}
              >
                <option value="">All Regions</option>
                <option value="North">🔴 North Indian</option>
                <option value="South">🟢 South Indian</option>
                <option value="East">🟡 East Indian</option>
                <option value="West">🟠 West Indian</option>
              </select>
            </div>
            
            <div>
              <label className="body-small block mb-1" style={{ color: 'rgb(24, 24, 24)' }}>Food Type</label>
              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ borderColor: 'rgba(24, 24, 24, 0.2)' }}
              >
                <option value="">All Types</option>
                <option value="veg">🥬 Vegetarian</option>
                <option value="non-veg">🍗 Non-Veg</option>
                <option value="vegan">🌱 Vegan</option>
              </select>
            </div>
            
            <div>
              <label className="body-small block mb-1" style={{ color: 'rgb(24, 24, 24)' }}>Category</label>
              <select
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ borderColor: 'rgba(24, 24, 24, 0.2)' }}
              >
                <option value="">All Categories</option>
                <option value="bread">🫓 Bread</option>
                <option value="dal">🍲 Dal</option>
                <option value="rice">🍚 Rice</option>
                <option value="main_course">🍛 Main Course</option>
                <option value="snack">🥙 Snack</option>
                <option value="dessert">🍰 Dessert</option>
              </select>
            </div>
            
            <div>
              <label className="body-small block mb-1" style={{ color: 'rgb(24, 24, 24)' }}>Log as</label>
              <select
                value={selectedMealType}
                onChange={(e) => setSelectedMealType(e.target.value)}
                className="w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ borderColor: 'rgba(24, 24, 24, 0.2)' }}
              >
                <option value="breakfast">Breakfast</option>
                <option value="lunch">Lunch</option>
                <option value="dinner">Dinner</option>
                <option value="snack">Snack</option>
              </select>
            </div>
          </div>
          
          {(filterRegion || filterType || filterCategory) && (
            <div className="mt-3 flex gap-2 flex-wrap">
              {filterRegion && (
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs" style={{ backgroundColor: 'rgba(243, 234, 255, 0.5)' }}>
                  Region: {filterRegion}
                  <button onClick={() => setFilterRegion('')} className="ml-1">×</button>
                </span>
              )}
              {filterType && (
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs" style={{ backgroundColor: 'rgba(243, 234, 255, 0.5)' }}>
                  Type: {filterType}
                  <button onClick={() => setFilterType('')} className="ml-1">×</button>
                </span>
              )}
              {filterCategory && (
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs" style={{ backgroundColor: 'rgba(243, 234, 255, 0.5)' }}>
                  Category: {filterCategory}
                  <button onClick={() => setFilterCategory('')} className="ml-1">×</button>
                </span>
              )}
              <button 
                onClick={() => { setFilterRegion(''); setFilterType(''); setFilterCategory(''); }}
                className="text-xs px-3 py-1 rounded-full hover:bg-gray-100"
                style={{ color: 'rgb(0, 128, 255)' }}
              >
                Clear all filters
              </button>
            </div>
          )}
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <p className="body-medium text-center" style={{ color: 'rgb(112, 112, 112)' }}>Loading...</p>
          ) : filteredFoods.length === 0 ? (
            <div className="text-center py-8">
              <p className="body-medium" style={{ color: 'rgb(112, 112, 112)' }}>No foods found matching your criteria</p>
              <p className="body-small mt-2" style={{ color: 'rgb(143, 143, 143)' }}>Try adjusting your search or filters</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {filteredFoods.map((food) => (
                <div
                  key={food.id}
                  className="p-4 rounded-lg border hover:shadow-md transition-shadow cursor-pointer"
                  style={{ borderColor: 'rgba(24, 24, 24, 0.1)' }}
                  onClick={() => logFood(food.id)}
                >
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="body-medium font-semibold" style={{ color: 'rgb(24, 24, 24)' }}>{food.name}</h3>
                    <div className="flex gap-1 ml-2">
                      {food.type === 'veg' && <span title="Vegetarian">🥬</span>}
                      {food.type === 'non-veg' && <span title="Non-Vegetarian">🍗</span>}
                      {food.type === 'vegan' && <span title="Vegan">🌱</span>}
                      {food.region === 'North' && <span title="North Indian">🔴</span>}
                      {food.region === 'South' && <span title="South Indian">🟢</span>}
                      {food.region === 'East' && <span title="East Indian">🟡</span>}
                      {food.region === 'West' && <span title="West Indian">🟠</span>}
                    </div>
                  </div>
                  
                  {food.category && (
                    <p className="text-xs mb-2 px-2 py-1 rounded-full inline-block" style={{ backgroundColor: 'rgba(243, 234, 255, 0.3)', color: 'rgb(112, 112, 112)' }}>
                      {food.category === 'bread' && '🫓 Bread'}
                      {food.category === 'dal' && '🍲 Dal'}
                      {food.category === 'rice' && '🍚 Rice'}
                      {food.category === 'main_course' && '🍛 Main Course'}
                      {food.category === 'snack' && '🥙 Snack'}
                      {food.category === 'dessert' && '🍰 Dessert'}
                      {!['bread', 'dal', 'rice', 'main_course', 'snack', 'dessert'].includes(food.category) && food.category}
                    </p>
                  )}
                  
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div>
                      <span style={{ color: 'rgb(112, 112, 112)' }}>Calories: </span>
                      <span style={{ color: 'rgb(24, 24, 24)' }}>{food.calories}</span>
                    </div>
                    <div>
                      <span style={{ color: 'rgb(112, 112, 112)' }}>Protein: </span>
                      <span style={{ color: 'rgb(24, 24, 24)' }}>{food.protein}g</span>
                    </div>
                    <div>
                      <span style={{ color: 'rgb(112, 112, 112)' }}>Carbs: </span>
                      <span style={{ color: 'rgb(24, 24, 24)' }}>{food.carbs}g</span>
                    </div>
                    <div>
                      <span style={{ color: 'rgb(112, 112, 112)' }}>Fat: </span>
                      <span style={{ color: 'rgb(24, 24, 24)' }}>{food.fat}g</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FoodDatabase;